module.exports = __webpack_public_path__ + "img/tradeViewBg.234883cb.png";